<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="action-toolbar">
    <div class="row flex-nowrap">
        <button (click)="triggerSittingsToolbar(true)" class="history-button" windeActionIcon>
            <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="projectView.mapActionsToolbar.btn.menu">
                <sui-svg-icon icon="bars"/>
            </winde-ctx-sensitive-help>
        </button>

        <div class="col">
            <input
                    (blur)="blurSearchInput()"
                    (focus)="focusSearchInput()"
                    (input)="handleInput()"
                    (keyup.enter)="selectSuggestion()"
                    [(ngModel)]="searchString"
                    autocomplete="off"
                    class="geocoding-input"
                    name="geocodingPlace"
                    placeholder="Search..."
                    type="text"
            />

            @if (hasSuggestions()) {
                <div
                        (blur)="preventClose.set(false)"
                        (focus)="preventClose.set(true)"
                        (mouseleave)="preventClose.set(false)"
                        (mouseover)="preventClose.set(true)"
                        class="autocomplete-suggestions custom-scroll-bar"
                >
                    @if (hasSuggestedStations()) {
                        @if (searchResults().stations.stationsByName?.length) {
                            <div class="autocomplete-suggestions__item_header">
                                {{ 'project.actionsToolbarSearch.searchByName' | translate }}
                            </div>
                            @for (station of searchResults().stations.stationsByName; track station.name) {
                                <div
                                        (click)="selectStation(station)"
                                        (keydown)="selectStation(station)"
                                        class="autocomplete-suggestions__item"
                                >
                                    {{ station.name }}
                                </div>
                            }
                        }
                        @if (searchResults().stations.stationsByAssignedName?.length) {
                            <div class="autocomplete-suggestions__item_header">
                                {{ 'project.actionsToolbarSearch.searchByAssignedName' | translate }}
                            </div>
                            @for (station of searchResults().stations.stationsByAssignedName; track station.deviceAN) {
                                <div
                                        (click)="selectStation(station)"
                                        (keydown)="selectStation(station)"
                                        class="autocomplete-suggestions__item"
                                >
                                    {{ station.deviceAN }}
                                </div>
                            }
                        }
                        @if (searchResults().stations.stationsByIPAddress?.length) {
                            <div class="autocomplete-suggestions__item_header">
                                {{ 'project.actionsToolbarSearch.searchByIP' | translate }}
                            </div>
                            @for (station of searchResults().stations.stationsByIPAddress; track station.deviceIP) {
                                <div
                                        (click)="selectStation(station)"
                                        (keydown)="selectStation(station)"
                                        class="autocomplete-suggestions__item"
                                >
                                    {{ station.deviceIP }}
                                </div>
                            }
                        }
                    }
                    @if (hasSuggestedLocations()) {
                        <div class="autocomplete-suggestions__item_header">
                            {{ 'project.actionsToolbarSearch.searchByLocation' | translate }}
                        </div>
                        @for (location of searchResults().locations; track location.placeId) {
                            <div
                                    (click)="selectLocation(location.text.text)"
                                    (keydown)="selectLocation(location.text.text)"
                                    class="autocomplete-suggestions__item"
                            >
                                {{ location.text.text }}
                            </div>
                        }
                    }
                </div>
            }
        </div>

        <button (click)="selectSuggestion()" class="history-button" windeActionIcon>
            <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="projectView.mapActionsToolbar.btn.search">
                <sui-svg-icon icon="search"/>
            </winde-ctx-sensitive-help>
        </button>

        <div class="col separator"></div>
        <button
                (click)="modeChanged(modeType.SELECT_AREA_MODE)"
                [disabled]="
                !historyService.isEditModeEnabled ||
                projectStateService.isBomConfigProject() ||
                projectStateService.isPotentiallyCorruptedProject()
            "
                [ngClass]="{ 'active': historyService.toolbarMode === modeType.SELECT_AREA_MODE }"
                class="history-button"
                windeActionIcon
        >
            <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="projectView.mapActionsToolbar.btn.area">
                <sui-svg-icon icon="square"/>
            </winde-ctx-sensitive-help>
        </button>
        <div class="col separator"></div>
        <button (click)="runUndo()"
                [disabled]="
                !historyService.isEditModeEnabled ||
                infoWindowsService.isWindowOpen ||
                !historyService.isUndoEnabled() ||
                isCommandsInProcess() ||
                projectStateService.isBomConfigProject() ||
                projectStateService.isPotentiallyCorruptedProject()
            "
                class="history-button"
                windeActionIcon
        >
            <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="projectView.mapActionsToolbar.btn.undo">
                <sui-svg-icon icon="undo"/>
            </winde-ctx-sensitive-help>
        </button>
        <button (click)="runRedo()"
                [disabled]="
                !historyService.isEditModeEnabled ||
                infoWindowsService.isWindowOpen ||
                !historyService.isRedoEnabled() ||
                isCommandsInProcess() ||
                projectStateService.isBomConfigProject() ||
                projectStateService.isPotentiallyCorruptedProject()
            "
                class="history-button"
                windeActionIcon
        >
            <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="projectView.mapActionsToolbar.btn.redo">
                <sui-svg-icon icon="redo"/>
            </winde-ctx-sensitive-help>
        </button>
    </div>
</div>
